import React from "react";

const StyledSmText = ({ children, fontColor }) => {
  return (
    <p className={`text-sm font-normal font-inter ${fontColor}`}>{children}</p>
  );
};

export default StyledSmText;
